import { render, staticRenderFns } from "./meta-project-number-field.vue?vue&type=template&id=b2383f12&scoped=true&"
import script from "./meta-project-number-field.vue?vue&type=script&lang=js&"
export * from "./meta-project-number-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2383f12",
  null
  
)

export default component.exports